import './legacy/jquery';
import './legacy/ignoreResizeObserverLoop';
import 'bootstrap';
import 'jquery-toast-plugin';
import 'vue-datepicker-next/index.css';
import '@googleworkspace/drive-picker-element'; // eslint-disable-line
import '../sass/settings.scss';

import { createApp, h, provide } from 'vue';
import * as VueNamespace from 'vue';
import {
  createRouter,
  createWebHashHistory,
  RouterView,
} from 'vue-router';
import { vuePlugin as launchDarklyPlugin } from '@tagboard/launchdarkly';
import { Userpilot } from 'userpilot';
import { useFormErrors } from 'vee-validate';
import instrument from './instrument';
import store from './store';
import applyPostLinksStyles from './directives/applyPostLinksStyles';
import filters from './utils/filters';
import { ErrorMessage, Field, Form } from './validation';

import AppComponent from './components/App.vue';
import ErrorComponent from './components/404.vue';
import ErrorPageComponent from './components/ErrorPage.vue';
import PointerEffect from './components/PointerEffect.vue';
import SidebarSettingsGroup from './components/SidebarSettingsGroup.vue';
import AccordionTransition from './components/AccordionTransition.vue';
import ColorPickerComponent from './components/Colorpicker.vue';
import SnippetPickerComponent from './components/SnippetPicker/SnippetPicker.vue';
import SnippetListItemComponent from './components/SnippetPicker/SnippetListItem.vue';
import EditComponent from './components/Edit.vue';
import RenderComponent from './components/Render.vue';
import CreateComponent from './components/Create.vue';

const routes = [
  { path: '/404', component: ErrorComponent, name: '404' },
  { path: '/error', component: ErrorPageComponent, name: 'error' },
  {
    path: '/',
    component: AppComponent,
    children: [
      {
        path: '',
        alias: 'create',
        component: CreateComponent,
        name: 'create',
      },
      { path: ':template_id', component: EditComponent, name: 'edit' },
      { path: 'render/:template_id', component: RenderComponent },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

const ValidationContent = {
  setup() {
    const validationErrors = useFormErrors();
    provide('validationErrors', validationErrors);
    return () => h(RouterView);
  },
};

const app = createApp({
  render() {
    return h(Form, { as: 'div', class: 'validation-root' }, {
      default: () => h(ValidationContent),
    });
  },
});

app.use(store);
app.use(router);
app.mixin({
  inject: {
    validationErrorsRef: {
      from: 'validationErrors',
      default: null,
    },
  },
  computed: {
    validationErrors() {
      return this.validationErrorsRef?.value || this.validationErrorsRef || {};
    },
  },
});
app.use(launchDarklyPlugin({
  userApi: process.env.USER_API,
  clientId: process.env.LAUNCH_DARKLY_CLIENT_ID,
}));
app.directive('apply-post-links-styles', applyPostLinksStyles);
app.component('AccordionTransition', AccordionTransition);
app.component('Colorpicker', ColorPickerComponent);
app.component('Snippetpicker', SnippetPickerComponent);
app.component('SnippetListItem', SnippetListItemComponent);
app.component('PointerEffect', PointerEffect);
app.component('SidebarSettingsGroup', SidebarSettingsGroup);
app.component('ValidationField', Field);
app.component('ValidationError', ErrorMessage);
app.config.globalProperties.$filters = filters;

instrument(app, router);
Userpilot.initialize(process.env.USERPILOT_TOKEN);
router.afterEach(() => { Userpilot.reload(); });

const mountedApp = app.mount('#app');

window.addEventListener('message', (event) => {
  if (typeof event.data === 'string' && event.data.indexOf('app:') === 0 && window.assetmanfn) {
    try {
      const payload = JSON.parse(event.data.replace('app:', ''));
      const { asset, meta = {} } = payload;
      window.assetmanfn({ asset, meta });
    } catch (error) {
      console.error('Failed to parse received message:', error);
    }
  }
}, false);

window.Vue = VueNamespace;
window.$vm = mountedApp;
